import React from 'react';
import { AlertCircle, Moon, Activity, Droplets, Battery, Flame, Coffee, Scale } from 'lucide-react';
export function PainSection() {
  const symptoms = [{
    icon: <Moon className="text-forest" size={20} data-id="element-359" data-mp="38vki6mduy1yy" />,
    signal: 'Vientre duro al acostarte',
    meaning: 'Fermentación activa en el intestino'
  }, {
    icon: <Droplets className="text-forest" size={20} data-id="element-360" data-mp="2yypl87x8g9ms" />,
    signal: 'Cara hinchada al despertar',
    meaning: 'Retención de líquidos por sodio oculto'
  }, {
    icon: <Battery className="text-forest" size={20} data-id="element-361" data-mp="2pz2hvgky0tr3" />,
    signal: 'Fatiga que no mejora con el sueño',
    meaning: 'Sistema inmune sobreactivado por inflamación'
  }, {
    icon: <Activity className="text-forest" size={20} data-id="element-362" data-mp="2bbzguzxew2z0" />,
    signal: 'Antojo dulce tras cenar',
    meaning: 'Pico de insulina descontrolado'
  }, {
    icon: <Flame className="text-forest" size={20} data-id="element-363" data-mp="228yhdi31xa4b" />,
    signal: 'Reflujo o acidez nocturna',
    meaning: 'Digestión incompleta bajo estrés'
  }, {
    icon: <Scale className="text-forest" size={20} data-id="element-364" data-mp="27anr8uejfhqt" />,
    signal: 'Peso estancado a pesar de comer poco',
    meaning: 'Cortisol crónico bloqueando la quema de grasa'
  }];
  return <section className="py-16 md:py-24 px-4 bg-cream relative" data-id="element-365" data-mp="3nknniu9hes9c">
      <div className="max-w-3xl mx-auto" data-id="element-366" data-mp="5fkj7brcak9z">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-8 text-center" data-id="element-367" data-mp="5faojavcnoxy">
          La Mentira Que Te Han Contado Durante Años
        </h2>

        <div className="space-y-4 text-lg text-dark/80 mb-10" data-id="element-368" data-mp="38vzxf3ienaqs">
          <p className="flex items-start gap-3" data-id="element-369" data-mp="38u6nnfchwaek">
            <span className="text-urgency font-bold mt-1" data-id="element-370" data-mp="33yhmj7ktulg5">✕</span>
            <span data-id="element-371" data-mp="3im2nauu8c8kw">
              Te han dicho que si comes menos y te mueves más, todo se
              soluciona.
            </span>
          </p>
          <p className="flex items-start gap-3" data-id="element-372" data-mp="3duugm6kab1bf">
            <span className="text-urgency font-bold mt-1" data-id="element-373" data-mp="2q61mmfn833jg">✕</span>
            <span data-id="element-374" data-mp="2q475zdizhxl6">
              Te han dicho que la ensalada de noche es lo más sano que puedes
              hacer.
            </span>
          </p>
          <p className="flex items-start gap-3" data-id="element-375" data-mp="p4bzndvt2rrb">
            <span className="text-urgency font-bold mt-1" data-id="element-376" data-mp="p3k4u5a18y23">✕</span>
            <span data-id="element-377" data-mp="u1vcqagroyho">
              Te han dicho que los productos "light" y "sin azúcar" son tus
              aliados.
            </span>
          </p>
        </div>

        <p className="text-xl font-bold text-dark mb-4 text-center" data-id="element-378" data-mp="12uyxl3tqsdmc">
          Y llevas años siguiendo ese consejo.
        </p>
        <p className="text-2xl font-serif font-bold text-forest mb-8 text-center" data-id="element-379" data-mp="65pt3jhis8g0">
          ¿Y sabes qué?
        </p>

        <p className="text-lg text-dark/80 mb-12 text-center max-w-2xl mx-auto" data-id="element-380" data-mp="b4kpjo8etvil">
          Sigues hinchada. Sigues cansada. Sigues despertándote con ese abdomen
          que no reconoces como tuyo.
        </p>

        <div className="bg-white p-6 md:p-10 rounded-2xl shadow-warm mb-12" data-id="element-381" data-mp="k60o8ypv496z">
          <p className="text-lg mb-6" data-id="element-382" data-mp="1qjzxu3sf8igj">
            Porque lo que nadie te ha explicado es esto:
          </p>
          <p className="text-xl font-bold text-forest mb-6" data-id="element-383" data-mp="1vib7adet0qy8">
            A partir de los 35 años, tu cuerpo procesa los alimentos nocturnos
            de una forma completamente distinta.
          </p>

          <ul className="space-y-4 text-dark/80 mb-8 list-disc pl-5 marker:text-gold" data-id="element-384" data-mp="20p9ktz8rur30">
            <li data-id="element-385" data-mp="1vwoux8szky4r">
              Después de las 7 PM, tu producción de enzimas digestivas cae hasta
              un 40%.
            </li>
            <li data-id="element-386" data-mp="1rulhiemrbjgu">Tu sensibilidad a la insulina disminuye drásticamente.</li>
            <li data-id="element-387" data-mp="1mymp8fyb5hb5">Tu motilidad intestinal se ralentiza.</li>
          </ul>

          <div className="space-y-4 text-dark/80 bg-cream-dark/30 p-6 rounded-xl border border-forest/10" data-id="element-388" data-mp="1hx71uh8nqypl">
            <p data-id="element-389" data-mp="1czx6kkyl7stu">
              Esto significa que la ensalada cruda que cenaste con tanta
              responsabilidad...{' '}
              <strong data-id="element-390" data-mp="18zn1daimd6g1">
                está fermentando en tu intestino mientras intentas dormir.
              </strong>
            </p>
            <p data-id="element-391" data-mp="33b1r3rbmr5vs">
              Que el yogur "sin grasa" está alterando tu microbiota con
              edulcorantes artificiales que la ciencia ya ha relacionado con{' '}
              <strong data-id="element-392" data-mp="3acyl6ilqnsap">inflamación crónica.</strong>
            </p>
            <p data-id="element-393" data-mp="3fcjh0k5m3kj7">
              Que el pan integral que elegiste sobre el pan blanco sigue
              disparando tu insulina nocturna y ordenando a tu cuerpo{' '}
              <strong data-id="element-394" data-mp="35f5dtm8p8s8u">almacenar grasa abdominal.</strong>
            </p>
          </div>
        </div>

        {/* Warning Callout */}
        <div className="bg-red-50 border-2 border-urgency/30 rounded-xl p-6 flex flex-col md:flex-row items-center gap-4 mb-16 shadow-sm" data-id="element-395" data-mp="2rni8yy0oybeg">
          <div className="bg-white p-3 rounded-full shrink-0" data-id="element-396" data-mp="2hq429q4kl0zc">
            <AlertCircle className="text-urgency" size={32} data-id="element-397" data-mp="2hroz5mecww0d" />
          </div>
          <p className="text-xl md:text-2xl font-bold text-urgency text-center md:text-left" data-id="element-398" data-mp="2mq8l3msya7sq">
            No fallaste en la dieta. La dieta te falló a ti.
          </p>
        </div>

        <p className="text-lg text-dark/80 mb-8 text-center" data-id="element-399" data-mp="2dp0ln1ep70x2">
          Y mientras tanto, tu cuerpo lleva meses, quizás años, enviándote
          señales que no sabías cómo interpretar:
        </p>

        {/* Symptoms Table */}
        <div className="bg-white rounded-2xl shadow-sm border border-forest/10 overflow-hidden mb-12" data-id="element-400" data-mp="1p4xhrybsrpeq">
          <div className="grid grid-cols-1 md:grid-cols-2 bg-forest text-white font-bold text-sm md:text-base" data-id="element-401" data-mp="234yk7i7pn4wb">
            <div className="p-4 border-b md:border-b-0 md:border-r border-white/20" data-id="element-402" data-mp="1z0ijrwgv8poh">
              🔴 Señal
            </div>
            <div className="p-4" data-id="element-403" data-mp="282hxofwl3dn7">Lo que realmente significa</div>
          </div>
          <div className="divide-y divide-forest/10" data-id="element-404" data-mp="280dwi5q2ksqm">
            {symptoms.map((item, index) => <div key={index} className={`grid grid-cols-1 md:grid-cols-2 text-sm md:text-base ${index % 2 === 0 ? 'bg-white' : 'bg-cream/50'}`} data-id="element-405" data-mp="2mql5luu6szen" data-mpi={index}>
                <div className="p-4 font-medium text-dark flex items-center gap-3 border-b md:border-b-0 md:border-r border-forest/10" data-id="element-406" data-mp="2vrjbkio6rgzv">
                  <span className="shrink-0 bg-cream-dark p-2 rounded-lg" data-id="element-407" data-mp="2qukjs6rzvm4u">
                    {item.icon}
                  </span>
                  {item.signal}
                </div>
                <div className="p-4 text-dark/80 flex items-center" data-id="element-408" data-mp="1tfptvm6govlt">
                  {item.meaning}
                </div>
              </div>)}
          </div>
        </div>

        {/* Emotional Closing */}
        <div className="text-center max-w-2xl mx-auto space-y-6" data-id="element-409" data-mp="227rtji8pi7v1">
          <p className="text-xl font-bold text-forest" data-id="element-410" data-mp="276kvcdemsafd">
            Y lo peor de todo no es físico.
          </p>
          <p className="text-lg text-dark/80" data-id="element-411" data-mp="2c4cxe08zpcxa">
            Lo peor es esa sensación de traición.
          </p>
          <p className="text-lg text-dark/80" data-id="element-412" data-mp="2h5abo1qvpmti">
            La sensación de hacer todo bien... y que tu cuerpo no responda.
          </p>
          <p className="text-lg text-dark/80" data-id="element-413" data-mp="2l3q78u1103ij">
            La frustración de mirarte en ese espejo cada mañana y no
            reconocerte.
          </p>
          <p className="text-lg text-dark/80" data-id="element-414" data-mp="qsuq33brzg45">
            La fatiga emocional de llevar años luchando contra algo que no
            entiendes.
          </p>

          <div className="mt-10 inline-block" data-id="element-415" data-mp="ehk75vxhk4sr">
            <span className="relative inline-block" data-id="element-416" data-mp="egsbkl3w272h">
              <span className="absolute inset-x-0 bottom-2 h-3 bg-gold/40 -z-10 transform -rotate-1" data-id="element-417" data-mp="9ih2wdpby2lu"></span>
              <span className="font-serif text-3xl md:text-4xl font-bold text-forest" data-id="element-418" data-mp="5h5l2ucp6lo7">
                💬 Eso termina hoy.
              </span>
            </span>
          </div>
        </div>
      </div>
    </section>;
}